import { useState, useEffect } from 'react';
import { Viewport } from '../types';

const BREAKPOINTS = {
  tablet: 768,
  desktop: 1024,
} as const;

function getViewportFromWidth(width: number): Viewport {
  if (width >= BREAKPOINTS.desktop) {
    return 'desktop';
  } else if (width >= BREAKPOINTS.tablet) {
    return 'tablet';
  } else {
    return 'mobile';
  }
}

function getCurrentViewport(): Viewport {
  return getViewportFromWidth(window.innerWidth);
}

export function useViewport() {
  const [viewport, setViewport] = useState<Viewport>(getCurrentViewport);

  useEffect(() => {
    const handleResize = () => {
      const newViewport = getCurrentViewport();
      setViewport(newViewport);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    viewport,
    isMobile: viewport === 'mobile',
    isTablet: viewport === 'tablet',
    isDesktop: viewport === 'desktop',
    isSmallScreen: window.innerHeight < 970, // From variables.scss: $small-screen-height
  };
}

